import styles from 'css/src/components/common/video-preview/ShareLinkLogo.module.scss';

import React from 'react';

import Tooltip, { PlacementEnum } from 'js/src/components/common/ui/Tooltip';

type ShareLinkLogoProps = {
    shareLink: string;
};

const ShareLinkLogo = React.memo(function ShareLinkLogo({ shareLink }: ShareLinkLogoProps) {
    return (
        <Tooltip title="Video created with Lumen5" placement={PlacementEnum.LEFT}>
            <a
                className={styles['share-link-logo']}
                href={shareLink}
                target="_blank"
                rel="noopener"
                aria-label="Video created with Lumen5"
                onClick={(e) => e.stopPropagation()}
            >
                <img
                    src="https://cdn.lumen5.com/lumen5-site-images/L5-logo/2024/Lumen5-Brandmark-Reverse-White.png"
                    alt="Lumen5"
                />
            </a>
        </Tooltip>
    );
});

export default ShareLinkLogo;
